import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../layout'

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('../views/login'),
    meta: { title: '登录' },
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/components/404'),
    meta: { title: '404' },
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [{
      path: '/home',
      component: () => import('../views/home/index'),
      meta: { title: '首页' }
    }]
  },
  {
    path: '/common',
    component: () => import('../views/common/index'),
    meta: { title: '常用应用设置' }
  },
  {
    path: '/personal',
    component: () => import('../views/personal/index'),
    meta: { title: '个人设置' }
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  document.title = `智慧校园 - ${to.meta.title}`
  next()
})

export default router
